export default "__VITE_ASSET__CiYRUPld__"